import React from 'react';

import { Box } from '@rover/kibble/core';
import FrequentlyAskedQuestion from '@rover/react-lib/src/pages/landing/SeoLocation/components/Footer/ServiceFaqs/FrequentlyAskedQuestion';

import { FAQItem } from '../types';

type Props = {
  items: FAQItem[];
};

const FAQAccordion = ({ items }: Props): JSX.Element => {
  return (
    <>
      {items.map((item, index) => (
        <FrequentlyAskedQuestion key={index} question={item.question} isOpen={item.isOpenByDefault}>
          <Box>{item.answer}</Box>
        </FrequentlyAskedQuestion>
      ))}
    </>
  );
};

export default FAQAccordion;
